import * as um from 'generated/api/um.api';

type CreateProfileConfigForDeviceUuid = um.paths['/open-api/profile-config'];
export type CreateProfileConfigForDeviceUuidParams = CreateProfileConfigForDeviceUuid['post']['parameters']['body']['dtoRequest'];
export type CreateProfileConfigForDeviceUuidResp = CreateProfileConfigForDeviceUuid['post']['responses']['200']['schema'];
